import { render, staticRenderFns } from "./FormServ.vue?vue&type=template&id=0e91fb36&"
import script from "./FormServ.vue?vue&type=script&lang=js&"
export * from "./FormServ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports